import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import momentTimeZone from 'moment-timezone';
import { delay, map, flatMap, switchMap } from 'rxjs/operators';

import { fetchReportResultAction, setAction } from 'one-state-call-history';
import { FETCH_REPORT_RESULT, RUN_REPORT } from 'one-state-call-history';
import { TransformResponse } from './transform';
import { ErrorObject } from 'one-state-error/src/errorobject';

import { toIsoString } from 'one-card-call-history/src/function';
import { CallHistoryModel } from 'one-card-call-history';

export const runReportEpic = (context: any) => (
    (action$: any) => {
        const { 
            log,
            server, 
            settings: { 
                epicendpoints: { runreport, apitoken },
                uisettings: { call_history_config }
            }
        } = context;
        return action$.pipe(
            ofType(RUN_REPORT),
            switchMap((action: any) => {
                const getRequest = () => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    let agentUsername = sessionStorage.getItem('agentName');
                    console.log("Agent Name",agentUsername)
                    const data: any = {};
                    data.folderName = call_history_config?.folderName;
                    data.reportName = call_history_config?.reportName;
                    data.timezone = call_history_config?.timezone;
                    data.userName = agentUsername;
                    const format="ddd, DD MMM YYYY HH:mm:ss"
                    data.startTime = toIsoString(action.payload.startDate, format, call_history_config?.timezone);
                    data.endTime = toIsoString(action.payload.endDate, format, call_history_config?.timezone);
                    const response = server.post({
                        path: runreport,
                        data: data,
                        headers: headers
                    })
                        .then((responsedata: any) => responsedata)
                        .catch((responseerror: any) => {
                            log.error(
                                'ccw-gadget-call-history-epic',
                                'fetch-call-history-epic', {
                                responseerror
                            }
                            );
                            let errorbuild: ErrorObject = {
                                source: "CallHistory",
                                type: "error",
                                status: responseerror?.status,
                                erroritems: responseerror?.errors
                            };
                            return errorbuild;
                        })
                    return from(response);
                }

                return getRequest()
                    .pipe(
                        delay(5000),
                        flatMap((response: any) => {
                            const actions: any = [];
                            if (response.status >= 400 || response.type === 'error' || response.length === 0) {
                                const callHistory: CallHistoryModel = {
                                    callHistoryData: [],
                                    status: 400
                                };
                                actions.push(setAction(callHistory));
                            } else {
                                actions.push(fetchReportResultAction(response))
                            }
                            return actions;
                        }
                    )
                )
            })
        )
    }
);

export const fetchReportResultEpic = (context: any) => (
    (action$: any) => {
        const { 
            log,
            server, 
            settings: { 
                epicendpoints: { reportresult, apitoken }
            }
        } = context;
        return action$.pipe(
            ofType(FETCH_REPORT_RESULT),
            switchMap((action: any) => {
                const actionPayload = action.payload;
                const getRequest = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    const data = {
                        "identifier": payload
                    };
                    const response = server.post({
                        path: reportresult,
                        data: data,
                        headers: headers
                    })
                        .then((responsedata: any) => responsedata)
                        .catch((responseerror: any) => {
                            log.error(
                                'ccw-gadget-call-history-epic',
                                'fetch-call-history-epic', {
                                responseerror
                            }
                            );
                            let errorbuild: ErrorObject = {
                                source: "CallHistory",
                                type: "error",
                                status: responseerror?.status,
                                erroritems: responseerror?.errors
                            };
                            return errorbuild;
                        })
                    return from(response);
                }

                return getRequest(actionPayload)
                    .pipe(
                        map((response: any) => TransformResponse(response, context))
                    )
                    .pipe(
                        flatMap(response => {
                            const actions: any = [];
                            let callHistory: CallHistoryModel = {};
                            if (response.error) {
                                callHistory = {
                                    callHistoryData: [],
                                    status:400
                                };
                                actions.push(setAction(callHistory));
                            } else {
                                callHistory = {
                                    callHistoryData: response.callHistoryData,
                                    status: 200
                                };
                                actions.push(setAction(callHistory));
                            }
                            return actions;
                        }
                    )
                )
            })
        )
    }
);
